import { BaseStoreModel } from "../store/model";

export class FunnelTemplateReducer extends BaseStoreModel {
    constructor(
        funnelData = new FunnelTemplate({}),
        funnel = new FunnelTemplate({}),
        currentPageReferenceId = null,
        pages = [],
        pageData = {}
    ) {
        super();
        this.pages = pages;
        this.currentPageReferenceId = currentPageReferenceId;
        this.funnelData = funnelData;
        this.funnel = funnel;
        this.pageData = pageData;
        this.metaUrl = funnelData.metaJsonUrl;
    }
}

export class FunnelTemplatesReducer extends BaseStoreModel {
    constructor(
        funnels = [],
        activeFunnels = [],
    ) {
        super();
        this.funnels = funnels;
        this.activeFunnels = activeFunnels;
    }
}
export class FunnelTemplate {
    constructor(funnelObj) {
        this.author = funnelObj.author;
        this.category = funnelObj.category;
        this.dateCreated = funnelObj.createdOn;
        this.dateUpdated = funnelObj.updatedOn;
        this.pages = funnelObj.page;
        this.active = funnelObj.active;
        this.fListFunnelTypeId = funnelObj.fListFunnelTypeId;
        this.metaJson = funnelObj.metaJson;
        this.publicMetaJson = funnelObj.publicMetaJson;
        this.referenceId = funnelObj.referenceId;
        this.isVisualizer = funnelObj.isVisualizer;
        this.status = funnelObj.status;
        this.title = funnelObj.title;
        this.thumbnailUrl = funnelObj.thumbnailUrl || null;
        this.userName = funnelObj.userName || "";
        this.price = funnelObj.price || 0;
    }
}
